export * from './domains-transfer-template';
